import { VFC } from 'react';
import { Badge, Table } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { ColumnsType } from 'antd/lib/table';
import { FormattedMessage } from 'react-intl';
import { FullWidthHeightSpace } from '../../../../../components/Space/FullWidthHeightSpace';
import { theme } from '../../../../../consts/themeBase';
import { LoraMessage } from '../../../../../hooks/useLoraMessages';
import { ContentSensorSuccess as contentSensorSuccessMessages } from '../messages';

interface ContentSensorSuccessProps {
  messages: LoraMessage[];
}

const getColumns = (): ColumnsType<LoraMessage> => [
  {
    dataIndex: 'datetime',
    key: 'datetime',
    title: <FormattedMessage {...contentSensorSuccessMessages.dateAndTime} />,
    width: 100,
    render: (_: unknown, { datetime }) => (
      <>
        {datetime.toLocaleString()} <small>({moment(datetime).fromNow()})</small>
      </>
    ),
  },
  {
    dataIndex: 'rssi',
    key: 'rssi',
    title: 'RSSI',
    width: 50,
  },
];

export const ContentSensorSuccess: VFC<ContentSensorSuccessProps> = ({ messages }) => {
  const columns = getColumns();

  return (
    <FullWidthHeightSpace direction="vertical">
      <div className="text-center">
        <CheckCircleOutlined style={{ color: theme.colors.main, fontSize: 100 }} />
      </div>
      <Badge status="success" text={<FormattedMessage {...contentSensorSuccessMessages.sensorRegistered} />} />
      <Badge status="success" text={<FormattedMessage {...contentSensorSuccessMessages.sensorSendsMessages} />} />
      <Table
        bordered
        columns={columns}
        dataSource={messages}
        pagination={false}
        rowKey={item => item.id}
        size="small"
      />
    </FullWidthHeightSpace>
  );
};
